import React from "react";
import "./BrowseTopicsButton.css";
import GradientButton from "../../../components/utilities/gradient-button/GradientButton";

const BrowseTopicsButton = ({ onClick }) => {
  return (
      <GradientButton onClick={onClick}>
          Browse Topics
      </GradientButton>
  );
};

export default BrowseTopicsButton;
